import { BmHttp } from "../utils/Global";
import { notifyCitaFinalizada, CITA_FINALIZADA_SENTINEL } from "../utils/citaFinalizadaAlert";

export const guardarExamenLaboratorioService = async (examen) => {
  try {
    const { data } = await BmHttp().post("examen_registro_cita", examen);
    return data;
  } catch (error) {
    if (notifyCitaFinalizada(error)) return CITA_FINALIZADA_SENTINEL;
    console.error(error);
  }
};

export const guardarExamenImagenesService = async (examen) => {
  try {
    const { data } = await BmHttp().post("examen_registro_cita_imagen_orden", examen);
    return data;
  } catch (error) {
    if (notifyCitaFinalizada(error)) return CITA_FINALIZADA_SENTINEL;
    console.error(error);
  }
};
/**
 * ORDENES-ANULAR-01: anula una orden de imagen y revierte las prestaciones por
 * cobrar que nacieron de ella. Exige el permiso `ordenes.anular` (403 si no lo
 * tiene). El backend rechaza además con 409/422 si alguna prestación ya está
 * facturada o si la orden es anterior al registro de trazabilidad; en todos
 * esos casos hay que mostrar SU mensaje, no uno genérico.
 */
export const anularOrdenImagenService = async (idexamen_imagen, motivo) => {
  try {
    const { data } = await BmHttp().post("examen_eliminar_cita_imagen_orden", { idexamen_imagen, motivo });
    return data;
  } catch (error) {
    if (notifyCitaFinalizada(error)) return CITA_FINALIZADA_SENTINEL;
    if (error.response?.status === 403) {
      return { success: false, message: "No tienes permiso para anular órdenes." };
    }
    return (
      error.response?.data || {
        success: false,
        message: "No se pudo anular la orden. Intente nuevamente.",
      }
    );
  }
};

export const guardarExamenInterconsultaService = async (examen) => {
  try {
    const { data } = await BmHttp().post("examen_registro_cita_interconsulta_orden", examen);
    return data;
  } catch (error) {
    if (notifyCitaFinalizada(error)) return CITA_FINALIZADA_SENTINEL;
    console.error(error);
  }
};
export const guardarExamenImagenExternaService = async (examen) => {
  try {
    const { data } = await BmHttp().post("examen_registro_cita_imagen_externa_orden", examen);
    return data;
  } catch (error) {
    if (notifyCitaFinalizada(error)) return CITA_FINALIZADA_SENTINEL;
    console.error(error);
  }
};

export const guardarTarifariosMasivos = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const { data } = await BmHttp().post("procedimientos_tarifario_masivo", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return data;
  } catch (error) {
    console.error("Error al subir tarifarios masivos:", error);
    return { success: false, message: "Error en la carga del archivo." };
  }
};




export const ListCategoriaExamenProcedimientos = async (value) => {
  try {
    if(value){
      const { data } = await BmHttp().post(`get_procedimientos_all`,{
        value
      });
      return data;
    }
    const { data } = await BmHttp().get(`get_procedimientos_all`);
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

// TARIFARIOS-PERF-01: los parametros son OPCIONALES y el endpoint sigue
// devolviendo la lista completa si no se pasa ninguno -- los otros 5
// consumidores de este servicio no cambian. Quien pase `seguro_id` deja de
// descargar el tarifario de las 19 aseguradoras (7,57 MB) para pintar una.
export const ListarProcedimientoConPrecios  = async (params) => {
  try {
    const { data } = await BmHttp().get(`get_procedimientos_all_precios`, params ? { params } : undefined);
    return data;
  } catch (error) {
    console.log("error", error);
    return { success: false, data: [], message: "No se pudo obtener el tarifario." };
  }
}

export const EliminarProcedimientoPrecio = async (idprocedimiento_company_precios) => {
  try {
    const { data } = await BmHttp().post(`delete_procedimiento_precio`,
      {idprocedimiento_company_precios}
    );
    return data;
  } catch (error) {
    console.log("error", error);
  }
}

/**
 * Crear procedimiento precio
 * @Object {
 *  idexamen_tipo: number,
  * precio: number,
  * idcompany: number
  *  descuento: number
 * }
 * 
 */
export const CrearProcedimientoPrecio = async (procedimiento) => {
  try {
    const { data } = await BmHttp().post(`create_procedimiento_precio`, procedimiento);
    return data;
  } catch (error) {
    console.log("error", error);
  }
}

export const ActualizarProcedimientoPrecio = async (procedimiento) => {
  try {
    const { data } = await BmHttp().post(`update_procedimiento_precio`, procedimiento);
    return data;
  } catch (error) {
    console.log("error", error);
  }
}

export const GetExamenesAll = async(page, limit, search) => {
  try {
    const { data } = await BmHttp().get(`examen/tipo`, {params: {page, limit, search }});
    return data;
      
  } catch (error) {
      return error.response.data;
  }
}